import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { atom, useAtom } from "jotai";
import Maintenance from "../contact_create/maintenance";
import { useEffect } from 'react';

const kubunAtom = atom();
const expAtom = atom();
const nasAtom = atom();
const hciAtom = atom();
const swAtom = atom();
const etcAtom = atom();
const targetAtom = atom();
const productsServiceAtom = atom();
const osAtom = atom();
const titleAtom = atom();
const detailAtom = atom();
const youtoAtom = atom();
const releaseAtom = atom();
const yosanAtom = atom();
const cnameAtom = atom();
const sectionAtom = atom();
const nameAtom = atom();
const kenAtom = atom();
const addressAtom = atom();
const tel1Atom = atom();
const tel2Atom = atom();
const tel3Atom = atom();
const emailAtom = atom();
const email2Atom = atom();
const ecnameAtom = atom();
const esectionAtom = atom();
const enameAtom = atom();
const etelAtom = atom();
const eemailAtom = atom();
const sessionKeyAtom = atom();

const kubunMap = {"1": "製品お問い合わせ", "2": "購入相談" };
const youtoMap = {"1": "自社導入", "2": "お客様提案" };
const releaseMap = {"1": "導入済み", "2": "未定", "3": "3ヶ月以内", "4": "半年以内", "5": "1年以内", "6": "1年以上先" };

function MainComponent({ handleLoading }) {

    document.title = "ファーストコンタクトセンター | NEC";
    const location = useLocation();
    const navigate = useNavigate();
    
    const [kubun, setKubun] = useAtom(kubunAtom);
    const [exp, setExp] = useAtom(expAtom);
    const [nas, setNas] = useAtom(nasAtom);
    const [hci, setHci] = useAtom(hciAtom);
    const [sw, setSw] = useAtom(swAtom);
    const [etc, setEtc] = useAtom(etcAtom);
    const [target, setTarget] = useAtom(targetAtom);
    const [productsService, setProductsService] = useAtom(productsServiceAtom);
    const [os, setOs] = useAtom(osAtom);
    const [title, setTitle] = useAtom(titleAtom);
    const [detail, setDetail] = useAtom(detailAtom);
    const [youto, setYouto] = useAtom(youtoAtom);
    const [release, setRelease] = useAtom(releaseAtom);
    const [yosan, setYosan] = useAtom(yosanAtom);
    const [cname, setCname] = useAtom(cnameAtom);
    const [section, setSection] = useAtom(sectionAtom);
    const [name, setName] = useAtom(nameAtom);
    const [ken, setKen] = useAtom(kenAtom);
    const [address, setAddress] = useAtom(addressAtom);
    const [tel1, setTel1] = useAtom(tel1Atom);
    const [tel2, setTel2] = useAtom(tel2Atom);
    const [tel3, setTel3] = useAtom(tel3Atom);
    const [email, setEmail] = useAtom(emailAtom);
    const [email2, setEmail2] = useAtom(email2Atom);
    const [ecname, setEcname] = useAtom(ecnameAtom); 
    const [esection, setEsection] = useAtom(esectionAtom);
    const [ename, setEname] = useAtom(enameAtom);
    const [etel, setEtel] = useAtom(etelAtom);
    const [eemail, setEemail] = useAtom(eemailAtom);
    const [sessionKey, setSessionKey] = useAtom(sessionKeyAtom);

    setKubun(location.state.kubun);
    setExp(location.state.exp);
    setNas(location.state.nas);
    setHci(location.state.hci);
    setSw(location.state.sw);
    setEtc(location.state.etc);

    const targetArr = [];
    if (location.state.exp) {
        targetArr.push("Express5800シリーズ");
    }
    if (location.state.nas) {
        targetArr.push("iStorageシリーズ");
    }
    if (location.state.hci) {
        targetArr.push("ハイパーコンバージドインフラストラクチャ");
    }
    if (location.state.sw) {
        targetArr.push("ソフトウェア・サービス");
    }
    if (location.state.etc) {
        targetArr.push("その他");
    }
    setTarget(targetArr.join("/"));

    setProductsService(location.state.productsService);
    setOs(location.state.os);
    setTitle(location.state.title);
    setDetail(location.state.detail);
    setYouto(location.state.youto);
    setRelease(location.state.release);
    setYosan(location.state.yosan);
    setCname(location.state.cname);
    setSection(location.state.section);
    setName(location.state.name);
    setKen(location.state.ken);
    setAddress(location.state.address);
    setTel1(location.state.tel1);
    setTel2(location.state.tel2);
    setTel3(location.state.tel3);
    setEmail(location.state.email);
    setEmail2(location.state.email2);
    setEcname(location.state.ecname);
    setEsection(location.state.esection);
    setEname(location.state.ename);
    setEtel(location.state.etel);
    setEemail(location.state.eemail);

    function initInput() {
    }

    const getSessionId = async (email) => {
        try {
            const path = process.env.REACT_APP_DcmApiEndpoint + "getSessionId";
            const myInit = {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer none`,
                    "mode": "cors",
                    "Referrer-Policy": "no-referrer",
                },
                body: JSON.stringify({ email: email })
            };
            const response = await fetch(path, myInit);
            
            const resJson = await response.json();
            if (resJson.resultStatus == 0) {
                setSessionKey(resJson.sessionKey);
                return resJson.sessionKey;
            } else {
                return false;
            }
        } catch (err) {
            return false;
        }
    }

    
    useEffect(() => {

        try {

            handleLoading(true);
            let data = getSessionId(location.state.email);
        } catch (e) {
            // TODO エラー表示
            ;
        } finally {
            handleLoading(false);
        }

    }, [email]);


    const confirm = async () => {
        handleLoading(true);
        try {

            const addConcat = async (
                kubun,
                model,
                productsService,
                os,
                title,
                detail,
                youto,
                release,
                yosan,
                cname,
                section,
                name,
                ken,
                address,
                tel1,
                tel2,
                tel3,
                email,
                email2,
                ecname,
                esection,
                ename,
                etel,
                eemail,            
                sessionKey
            ) => {
                let param = {
                    kubun:               kubun,
                    model:               model,
                    productsService:     productsService,
                    os:                  os,
                    title:               title,
                    detail:              detail,
                    youto:               youto,
                    release:             release,
                    yosan:               yosan,
                    cname:               cname,
                    section:             section,
                    name:                name,
                    ken:                 ken,
                    address:             address,
                    tel1:                tel1,
                    tel2:                tel2,
                    tel3:                tel3,
                    email:               email,
                    email2:              email2,
                    ecname:              ecname,
                    esection:            esection,
                    ename:               ename,
                    etel:                etel,
                    eemail:              eemail,
                    sessionKey:          sessionKey
                };

                try {
                    const path = process.env.REACT_APP_DcmApiEndpoint + "addContact";
                    const myInit = {
                        method: "POST",
                        headers: {
                            "Accept": "application/json",
                            "Authorization": `Bearer none`,
                            "mode": "cors",
                            "Referrer-Policy": "no-referrer",
                        },
                        body: JSON.stringify(param)
                    };
                    const response = await fetch(path, myInit);
                    
                    const resJson = await response.json();
                    return resJson.resultStatus;
                } catch (err) {
                    return 9;
                }
            }


            let data = await addConcat(
                kubun,
                target,
                productsService,
                os,
                title,
                detail,
                youtoMap[youto],
                releaseMap[release],
                yosan,
                cname,
                section,
                name,
                ken,
                address,
                tel1,
                tel2,
                tel3,
                email,
                email2,
                ecname,
                esection,
                ename,
                etel,
                eemail,
                sessionKey);
            if (data === 1) {
                alert("一定時間が経過したため、セッションが切れました。一度、「入力内容を修正する」ボタンにて前画面に戻り、再度「入力内容を確認する」ボタンで本画面を表示して操作を継続してください。");
                throw new Error("追加失敗");
            }
            if (data !== 0) {
                alert("現在サーバーが込み合っているか、または、システムメンテナンス中です。時間を置いて再試行してください。尚、特定のセキュリティ上のリスクを伴う文字・表現が含まれている場合にもエラーとなる可能性がございます。詳細は前ページの「お問い合わせ・ご相談内容」の説明をご覧ください。");
                throw new Error("追加失敗");
            }
            handleLoading(false);
            initInput();
            navigate("/contact_complete", { 
                state: {
                    kubun: location.state.kubun,
                    exp: location.state.exp,
                    nas: location.state.nas,
                    hci: location.state.hci,
                    sw: location.state.sw,
                    etc: location.state.etc,
                    productsService: location.state.productsService,
                    os: location.state.os,
                    title: location.state.title,
                    detail: location.state.detail,
                    youto: location.state.youto,
                    release: location.state.release,
                    yosan: location.state.yosan,
                    cname: location.state.cname,
                    section: location.state.section,
                    name: location.state.name,
                    ken: location.state.ken,
                    address: location.state.address,
                    tel1: location.state.tel1,
                    tel2: location.state.tel2,
                    tel3: location.state.tel3,
                    email: location.state.email,
                    email2: location.state.email2,
                    ecname: location.state.ecname,
                    esection: location.state.esection,
                    ename: location.state.ename,
                    etel: location.state.etel,
                    eemail: location.state.eemail,
                    page: true
                }
            });
        } catch (e) {
            // TODO エラー表示
            ;
        } finally {
            handleLoading(false);
        }
    };
    const goBack = () => {

        navigate("/contact_create", {
            state: {
                kubun: location.state.kubun,
                exp: location.state.exp,
                nas: location.state.nas,
                hci: location.state.hci,
                sw: location.state.sw,
                etc: location.state.etc,
                productsService: location.state.productsService,
                os: location.state.os,
                title: location.state.title,
                detail: location.state.detail,
                youto: location.state.youto,
                release: location.state.release,
                yosan: location.state.yosan,
                cname: location.state.cname,
                section: location.state.section,
                name: location.state.name,
                ken: location.state.ken,
                address: location.state.address,
                tel1: location.state.tel1,
                tel2: location.state.tel2,
                tel3: location.state.tel3,
                email: location.state.email,
                email2: location.state.email2,
                ecname: location.state.ecname,
                esection: location.state.esection,
                ename: location.state.ename,
                etel: location.state.etel,
                eemail: location.state.eemail,
                page: true
            }
        });
        initInput();
    }
    return (
        <div className="ls-row str-column-main" id="ls-row-3-col-1-row-2-col-2-row-1">
            <div className="str-outer">
                <div className="str-inner">
                    <h2 className="mod-hdg-l2-02">
                        <span>入力内容の確認</span>
                    </h2>
                    <div className="mod-tbl-form">
                        <div style={{ marginBottom: "15px" }}>
                            <div> 入力内容をご確認ください。</div>
                            <div> よろしければ<strong>「この内容で送信する」</strong>ボタンクリックしてください。</div>
                            <div> 内容を変更する場合は<strong>「入力内容を修正する」</strong>ボタンをクリックして修正してください。</div>
                        </div>
                        <table role="presentation">
                            <colgroup>
                                <col className="w-35" />
                                <col />
                            </colgroup>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">お問い合わせ・ご相談区分</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="kubun">{kubunMap[kubun]}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">お問い合わせ対象・ご検討機種</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="target" className="mod-txt">{target}</div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">お問い合わせ製品・サービス</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <ul className="list">
                                            <li>
                                                <div className="mod-txt mb-0">
                                                    <b className="label"><strong>製品名・サービス名、モデル(型番)</strong></b>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="mod-txt">{productsService}</div>
                                            </li>
                                            <li>
                                                <div className="mod-txt mb-0">
                                                    <b className="label"><strong>OS</strong></b>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="mod-txt">{os}</div>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="title">件名</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="title" className="text-pre-wrap">{title}</div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">お問い合わせ・ご相談内容</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="detail" className="text-pre-wrap">{detail}</div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">ご利用予定</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="youto">{youtoMap[youto]}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">ご導入予定時期</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="release">{releaseMap[release]}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">ご予算</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="yosan" className="text-pre-wrap">{yosan}</div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">正式会社名／団体名</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="cname" className="text-pre-wrap">{cname}</div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">ご所属</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="section" className="text-pre-wrap">{section}</div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">お名前</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="name" className="text-pre-wrap">{name}</div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">ご住所</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <ul className="list">
                                            <li>
                                                <div className="mod-txt mb-0">
                                                    <b className="label"><strong>都道府県</strong></b>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="mod-txt">{ken}</div>
                                            </li>
                                            <li>
                                                <div className="mod-txt mb-0">
                                                    <b className="label"><strong>市区町村以降</strong></b>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="mod-txt">{address}</div>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">お電話番号</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="tel1" className="text-pre-wrap">{tel1}-{tel2}-{tel3}</div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">E-Mail</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="email" className="text-pre-wrap">{email}</div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">担当営業</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <ul className="list">
                                            <li>
                                                <div className="mod-txt mb-0">
                                                    <b className="label"><strong>会社名</strong></b>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="mod-txt">{ecname}</div>
                                            </li>
                                            <li>
                                                <div className="mod-txt mb-0">
                                                    <b className="label"><strong>所属</strong></b>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="mod-txt">{esection}</div>
                                            </li>
                                            <li>
                                                <div className="mod-txt mb-0">
                                                    <b className="label"><strong>担当者名</strong></b>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="mod-txt">{ename}</div>
                                            </li>
                                            <li>
                                                <div className="mod-txt mb-0">
                                                    <b className="label"><strong>電話番号</strong></b>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="mod-txt">{etel}</div>
                                            </li>
                                            <li>
                                                <div className="mod-txt mb-0">
                                                    <b className="label"><strong>E-Mail</strong></b>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="mod-txt">{eemail}</div>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>

                        </table>
                    </div>
                    <div className="mod-btn of-list">
                        <div className="btn">
                            <button id="btn-go-top" className="of-left"
                                onClick={goBack}>入力内容を修正する</button>
                        </div>
                        <div className="btn">
                            <button id="btn-send" className="btn_default_select" onClick={confirm}>この内容で送信する</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default MainComponent;